import { render, staticRenderFns } from "./ExpressLayout.vue?vue&type=template&id=6278297a&scoped=true&"
import script from "./ExpressLayout.vue?vue&type=script&lang=js&"
export * from "./ExpressLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6278297a",
  null
  
)

export default component.exports